import { createFileRoute } from "@tanstack/react-router";
import ArticleEditor from "@/pages/admin/ArticleEditor";

export const Route = createFileRoute("/admin/articles/new")({
  component: ArticleEditor,
});
